export default "__VITE_ASSET__Cf2W3MqF__"